import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { Modal } from '@redq/reuse-modal';
import { theme } from 'common/theme/appModern';
import { ResetCSS } from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/AppModern/Navbar';
import Banner from 'containers/AppModern/Banner';
import About from 'containers/AppModern/About';
import AdminApp from 'containers/AppModern/AdminApp';
import ClientApp from 'containers/AppModern/ClientApp';
import WebApp from 'containers/AppModern/WebApp';
import Pricing from 'containers/AppModern/Pricing';
// import TeamPortfolio from 'containers/AppModern/TeamPortfoilo';
import Faq from 'containers/AppModern/Faq';
import Footer from 'containers/AppModern/Footer';
import Testimonial from 'containers/AppModern/Testimonial';
import NewsLetter from '../containers/AppModern/NewsLetter';
// import Dashboard from 'containers/AppModern/Dashboard';
import GlobalStyle, {
  AppWrapper,
  ContentWrapper,
} from 'containers/AppModern/appModern.style';
import '@redq/reuse-modal/es/index.css';
import '../components/i18next'
import SEO from 'components/seo';
import './style.css';

export default function () {
  // This part hides and shows download button in the navbar
  const myRef = useRef();
  const [isDownloadButtonVisible, setIsDownloadButtonVisible] = useState(false);

  useLayoutEffect(() => {
    const { current } = myRef;
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setIsDownloadButtonVisible(entry.isIntersecting);
    });
    observer.observe(current);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <>
        <SEO title="Skenit" />
        <Modal />
        <ResetCSS />
        <GlobalStyle />

        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar buttonVisible={isDownloadButtonVisible} />
          </Sticky>
          <ContentWrapper>
            <Banner myRef={myRef} />
            <About />
            <AdminApp />
            {/* <WebApp /> */}
            <ClientApp />
            <Pricing />
            {/* <TeamPortfolio /> */}
            <Testimonial />
          </ContentWrapper>
          <Faq />
          {/* <NewsLetter /> */}
          <Footer />
        </AppWrapper>
      </>
    </ThemeProvider>
  );
}
